import React, { useState } from "react";
import TableHeader from "./TableHeader";
import { TableRows } from "./TableRows";
import ALoader from "views/pages/manage/common/a-loader";
import RepresentDialoge from "./RepresentDialoge";

const JodoListing = ({
    loader,
    setLoader,
    getPaymentDetail,
    rows = [],
    currentApplicationDetails
}) => {
    const [representRow, setRepresentRow] = useState(null);

    const representHandler = (row) => {
        setRepresentRow(row);
    };
    return loader ? (
        <ALoader position="fixed" />
    ) : (
        <>
            <TableHeader />
            <TableRows
                rows={rows}
                representHandler={representHandler}
                representRow={representRow}
                setRepresentRow={setRepresentRow}
                currentApplicationDetails={currentApplicationDetails}
            />
            <RepresentDialoge
                isOpen={!!representRow}
                setOpen={setRepresentRow}
                row={representRow}
                setLoader={setLoader}
                getPaymentDetail={getPaymentDetail}
            />
        </>
    );
};
export default JodoListing;
